// extracted by mini-css-extract-plugin
module.exports = {"InputText":"InputText_InputText__7I60V","inputContainer":"InputText_inputContainer__6YyY_","placeHolder":"InputText_placeHolder__sFUPB","keyboard":"InputText_keyboard__13qmh"};